import $ from 'jquery';
import Flickity from 'flickity';

import 'flickity-as-nav-for';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';

import { VehicleIntro, VehicleIntroThumbs } from './custom/vehicleIntro';
import { ISMOBILE, ISTABLET, ISDESKTOP, ISLARGEDESKTOP } from './constants/commonConstants';

export let defaultCarouselOptions = {
	arrowShape: 'm37.371 50.129 20.833-20.833 4.425 4.425-16.408 16.408L62.63 66.538l-4.425 4.425z',
	cellSelector: '.carousel__slide',
	imagesLoaded: true,
	pageDots: false,
	lazyLoad: false,
	accessibility: true,
};

$('.carousel').each(function () {
	const carousel = $(this);
	const carouselOptions = {
		...defaultCarouselOptions,
	};

	// Thumb carousels
	if (carousel.is('[data-flickity-as-nav-for]')) {
		$.extend(true, carouselOptions, {
			asNavFor: carousel.data('flickity-as-nav-for'),
			contain: true,
			pageDots: false,
			prevNextButtons: true,
		});
	}

	// Button carousels
	if (carousel.hasClass('carousel--has-buttons')) {
		$.extend(true, carouselOptions, {
			prevNextButtons: true,
		});
	}

	// Page dots carousels
	if (carousel.hasClass('carousel--has-page-dots')) {
		$.extend(true, carouselOptions, {
			pageDots: true,
		});
	}

	// Wrap around carousels
	if (carousel.hasClass('carousel--wrap-around')) {
		$.extend(true, carouselOptions, {
			wrapAround: true,
			cellAlign: 'left',
		});
	}

	// No wrap around carousels
	if (carousel.hasClass('carousel-md--no-wrap-around') && ISTABLET) {
		$.extend(true, carouselOptions, {
			wrapAround: false,
			groupCells: true,
		});
	}

	if (carousel.hasClass('carousel-lg--no-wrap-around') && ISDESKTOP) {
		$.extend(true, carouselOptions, {
			wrapAround: false,
			groupCells: true,
		});
	}

	if (carousel.hasClass('carousel-xl--no-wrap-around') && ISLARGEDESKTOP) {
		$.extend(true, carouselOptions, {
			wrapAround: false,
			groupCells: true,
		});
	}

	// Overflow carousel
	if (carousel.hasClass('carousel--overflow')) {
		$.extend(true, carouselOptions, {
			cellAlign: ISMOBILE ? 'center' : 'left',
			contain: true,
		});
	}

	// Intro carousels
	if (carousel.hasClass('carousel--intro') && !carousel.hasClass('carousel--thumbs')) {
		$.extend(true, carouselOptions, {
			contain: true,
			pageDots: false,
			prevNextButtons: true,
			on: {
				ready : () => {
					const element = document.querySelector('.carousel__amount');
					if (element) element.innerHTML = `<p>1 / ${element.dataset.max}</p>`;
				},
				change: (index) => {
					const element = document.querySelector('.carousel__amount');
					if (element) element.innerHTML = `<p>${index + 1} / ${element.dataset.max}</p>`;
				}
			}
		});
	}

	// Vehicle modal carousel
	if (carousel.hasClass('carousel--vehicle-images-slider')) {
		$.extend(true, carouselOptions, {
			on: {
				ready : () => {
					const element = document.querySelector('.carousel__amount__modal');
					if (element) element.innerHTML = `<p>1 / ${element.dataset.max}</p>`;
				},
				change: (index) => {
					const element = document.querySelector('.carousel__amount__modal');
					if (element) element.innerHTML = `<p>${index + 1} / ${element.dataset.max}</p>`;
				}
			}
		});
	}

	if (carousel.hasClass('carousel--intro') && carousel.hasClass('carousel--thumbs')) {
		$.extend(true, carouselOptions, {
			cellAlign: 'left',
			contain: true,
		});
	}

	// Slider carousel
	if (carousel.hasClass('carousel--slider')) {
		$.extend(true, carouselOptions, {
			contain: true,
			draggable: true,
			pageDots: true,
			prevNextButtons: true,
		});
	}

	// Contacts carousel
	if (carousel.hasClass('carousel--contacts')) {
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		$.extend(true, carouselOptions, {
			autoPlay: (ISDESKTOP && !prefersReducedMotion) ? 7000 : false,
			pauseAutoPlayOnHover: true,
			contain: true,
			draggable: true,
			pageDots: false,
			prevNextButtons: false,
		});
	}

	if (carousel.hasClass('carousel--media-thumbs') && carousel.hasClass('carousel--thumbs')) {
		$.extend(true, carouselOptions, {
			cellAlign: 'center',
			contain: true,
			draggable: true,
			pageDots: false,
			prevNextButtons: false,
			wrapAround: false,
		});
	}

	// Models/Editions carousel
	if (carousel.hasClass('carousel--models')) {
		$.extend(true, carouselOptions, {
			cellAlign: 'left',
			draggable: true,
			watchCSS: true,
		});
	}

    // USPs carousel
    if (carousel.hasClass('carousel--usps')) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        $.extend(true, carouselOptions, {
            cellAlign: 'left',
            draggable: true,
            prevNextButtons: false,
            watchCSS: true,
            autoPlay: prefersReducedMotion ? false : 4000,
            pauseAutoPlayOnHover: true,
        });

        carousel.on('dragStart', function( event, pointer ) {
            document.ontouchmove = function (e) {
                e.preventDefault();
            }
        });
        carousel.on('dragEnd', function( event, pointer ) {
            document.ontouchmove = function (e) {
                return true;
            }
        });
    }


    // Models/Editions carousel
	if (carousel.hasClass('carousel--watch-css')) {
		$.extend(true, carouselOptions, {
			watchCSS: true,
		});
	}

    if (carousel.hasClass('carousel--banner-visual')) {
        $.extend(true, carouselOptions, {
            wrapAround: true,
            cellAlign: ISMOBILE ? 'center' : 'left',
            pageDots: ISMOBILE,
            prevNextButtons: false,
        })
    }

    if (carousel.hasClass('carousel--private-lease-assurances')) {
        $.extend(true, carouselOptions, {
            contain: true,
            watchCSS: true,
            cellAlign: 'left',
            groupCells: true,
            pageDots: true,
            prevNextButtons: false,
		});
    }

	// Instantiate
	const flkty = new Flickity(this, carouselOptions);

	if (carousel.hasClass('carousel--intro') && !carousel.hasClass('carousel--thumbs')) {
		new VehicleIntro(this, flkty);
	}

	if (carousel.hasClass('carousel--intro') && carousel.hasClass('carousel--thumbs')) {
		new VehicleIntroThumbs(this, flkty);
	}

	if (carousel.hasClass('carousel--parallax')) {
		const slideImages = this.querySelectorAll('.carousel__media');
		const prefersReducedMotionParallax = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (slideImages !== null && !prefersReducedMotionParallax) {
			flkty.on('scroll', () => {
				flkty.slides.forEach((slide, slideIndex) => {
					const img = slideImages[slideIndex];
					const x = ((slide.target + flkty.x) * -1) / 4;
					img.style.transform = 'translateX( ' + x + 'px)';
				});
			});
		}
	}

	if (carousel.hasClass('carousel--vehicle-images-slider')) {
        const triggerElements = Array.from(document.querySelectorAll('[data-slide-to-image]'));
		if (triggerElements) {
			triggerElements.forEach((trigger) => {
				trigger.addEventListener('click', () => {
					flkty.select(trigger.dataset.slideToImage - 1);
				})
			});
		}
    }

    if (carousel.hasClass('carousel--usps')) {
        flkty.on('dragStart', function( event, pointer ) {
            document.ontouchmove = function (e) {
                e.preventDefault();
            }
        });
        flkty.on('dragEnd', function( event, pointer ) {
            document.ontouchmove = function (e) {
                return true;
            }
        });
    }
});
